import shade from './component/colorshade'
 
const LightenDarkenColor = shade;


export {LightenDarkenColor};